import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Zap, Clock } from 'lucide-react';
import CalculatorLuxury from '../components/CalculatorLuxury';
import { BRAND } from '../brand';

const Cotizar = () => {
  useEffect(() => {
    try {
      const backend = process.env.REACT_APP_BACKEND_URL;
      fetch(`${backend}/api/analytics/track-visit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: '/cotizar' }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* silent */ }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-md mx-auto px-4 py-2 flex items-center justify-between">
          <Link
            to="/login"
            className="flex items-center gap-1.5 text-slate-600 hover:text-slate-900 text-sm font-medium"
            data-testid="cotizar-back-to-login"
          >
            <ArrowLeft size={18} />
            Volver
          </Link>
          <img src="/logo-oficial-horizontal.png" alt={`${BRAND.name}`} className="h-10 sm:h-12" />
          <div className="w-14" />
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 pt-6 pb-24">
        {/* Title */}
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-slate-900 mb-2" data-testid="cotizar-title">
            Cotiza tu envío
          </h1>
          <p className="text-slate-500 text-sm">
            Calcula cuánto recibirá tu familia en {BRAND?.exchange?.primary?.name || 'destino'}
          </p>
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-3 gap-2 mb-6">
          <div className="bg-white border border-slate-200 rounded-xl p-3 text-center">
            <Zap size={18} className="mx-auto text-green-600 mb-1" />
            <p className="text-[11px] text-slate-700 font-semibold leading-tight">5 minutos</p>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-3 text-center">
            <Shield size={18} className="mx-auto text-green-600 mb-1" />
            <p className="text-[11px] text-slate-700 font-semibold leading-tight">100% Seguro</p>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-3 text-center">
            <Clock size={18} className="mx-auto text-green-600 mb-1" />
            <p className="text-[11px] text-slate-700 font-semibold leading-tight">24/7</p>
          </div>
        </div>

        {/* Calculator */}
        <div data-testid="cotizar-calculator-wrapper">
          <CalculatorLuxury />
        </div>

        {/* CTA */}
        <div className="mt-6 bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-5 text-center">
          <p className="text-slate-700 text-sm mb-3">
            ¿Te gusta la tasa? Crea tu cuenta gratis y envía en minutos
          </p>
          <Link
            to="/register"
            className="block w-full h-12 leading-[3rem] bg-green-700 hover:bg-green-800 text-white rounded-xl font-semibold text-base shadow-sm transition-all active:scale-[0.98]"
            data-testid="cotizar-register-cta"
          >
            Crear cuenta gratis →
          </Link>
          <Link
            to="/login"
            className="block mt-3 text-sm text-slate-600 hover:text-slate-900"
            data-testid="cotizar-login-link"
          >
            ¿Ya tienes cuenta? <span className="font-semibold text-green-700">Ingresar</span>
          </Link>
        </div>

        {/* Footer info */}
        <p className="text-center text-xs text-slate-400 mt-6">
          {BRAND.name} · Operado por {BRAND.legalName}
          {BRAND?.exchange?.primary?.name ? ` · Chile → ${BRAND.exchange.primary.name}` : ''}
        </p>
      </main>
    </div>
  );
};

export default Cotizar;
